export const API_URL = "https://foods-api.avantisoftware.com.br"